import React from 'react';
export const CFIconPower = {
    alias: 'power',
    defaultTitle: 'Power',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M13 12a1 1 0 1 1-2 0V2a1 1 0 1 1 2 0v10Zm2.239-8.458a1 1 0 0 1 1.347-.43A9.973 9.973 0 0 1 22 12c0 5.513-4.486 10-10 10S2 17.514 2 12a9.972 9.972 0 0 1 5.415-8.89 1 1 0 0 1 .918 1.778A7.977 7.977 0 0 0 4 12c0 4.41 3.589 8 8 8s8-3.59 8-8a7.978 7.978 0 0 0-4.332-7.112.999.999 0 0 1-.429-1.347Z' }))),
};
